import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiPut } from '@/features/shared/utils/dataFetching'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { calculateTotalPages } from '@/features/shop/services/Search/utils'
import { useUserId } from '@/features/account/services/User/hooks'
import { infinitePurchaseHistoryQueryOptions } from '@/features/shop/services/Search/queryOptions'
import { useValidSearchParams } from '@/features/shared/hooks/search'
import { CMS_RHP_SLUG, CMS_GHP_SLUG } from '@/features/cms/services/CMS/queries'
import { getCMSQueryKeySlug } from '@/features/cms/services/CMS/queryOptions'

export const useMutationManagePurchaseHistoryVisibility = () => {
  const queryClient = useQueryClient()
  const userId = useUserId()
  const storeParams = useStoreParams()
  const params = useValidSearchParams()

  return useMutation({
    mutationFn: (product: { id: number }) =>
      apiPut<void>({
        config: {
          url: '/search/v4/purchase-history/update_hidden_flag',
          data: {
            user_id: userId,
            product_id: product.id,
            hidden: true,
          },
        },
        fetcherName: 'useMutationManagePurchaseHistoryVisibility',
      }),
    onSuccess: (_response, product) => {
      const { queryKey } = infinitePurchaseHistoryQueryOptions({
        storeParams,
        params,
      })
      queryClient.invalidateQueries({
        queryKey: [getCMSQueryKeySlug(CMS_GHP_SLUG)],
      })
      queryClient.invalidateQueries({
        queryKey: [getCMSQueryKeySlug(CMS_RHP_SLUG)],
      })
      const previousPurchaseHistory = queryClient.getQueryData(queryKey)

      if (previousPurchaseHistory) {
        queryClient.setQueryData(queryKey, {
          ...previousPurchaseHistory,
          pages: previousPurchaseHistory.pages.map((page) => ({
            ...page,
            products: page.products?.filter((p) => p.id !== product.id),
            totalPages: calculateTotalPages(page.total_hits - 1),
            total_hits: page.total_hits - 1,
          })),
        })
      }
    },
  })
}
